import { graphql } from "@/graphql/codegen"

graphql(`
  query GetCustomerProductPricing($input: GetPriceChangeItemsInput!) {
    priceChange {
      getPriceChangeItems(input: $input) {
        ... on GetPriceChangeItemsSuccess {
          priceChangeItems {
            groups {
              incoterms
              incotermsLocation {
                ...LocationBaseFields
              }
              shipFromWarehouseArea {
                location {
                  ...LocationBaseFields
                }
              }
              items {
                id
                customerId
                customer {
                  name
                }
                shipTo {
                  ...LocationBaseFields
                }
                effectiveDate
                expirationDate
                freightTerms
                tiers {
                  id
                  qty
                  uomId
                  price
                }
              }
            }
          }
        }
        ... on GetPriceChangeItemsFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
